import { combineReducers } from "redux";

// Authentication
import LoginReducer from "./auth/login/reducer";
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import RegisterReducer from "./auth/register/reducer";

// Course
import CourseReducer from "./Course/reducer";

// CourseWeb (public web courses)
import CourseWebReducer from "./CourseWeb/reducer";

// PayGCC
import PayGCCReducer from "./paygcc/reducer";

// Product
import ProductReducer from "./Product/reducer";

// ProductWeb (public web products)
import ProductWebReducer from "./ProductWeb/reducer";

const rootReducer = combineReducers({
  Login: LoginReducer,
  ForgetPassword: ForgetPasswordReducer,
  Register: RegisterReducer,
  course: CourseReducer,
  courseWeb: CourseWebReducer,
  paygcc: PayGCCReducer,
  product: ProductReducer,
  productWeb: ProductWebReducer,
});

export default rootReducer;
